export default __webpack_public_path__ + "static/media/T660_SOV.911293d7.pdf";